import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 17"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M19.5 4.5V.75a.75.75 0 0 0-.75-.75H15a.75.75 0 1 0 0 1.5h3v3a.75.75 0 1 0 1.5 0M1.5 15h3a.75.75 0 1 1 0 1.5H.75a.75.75 0 0 1-.75-.75V12a.75.75 0 1 1 1.5 0zm17.25-3.75A.75.75 0 0 0 18 12v3h-3a.75.75 0 1 0 0 1.5h3.75a.75.75 0 0 0 .75-.75V12a.75.75 0 0 0-.75-.75M1.5 4.5a.75.75 0 0 1-1.5 0V.75A.75.75 0 0 1 .75 0H4.5a.75.75 0 1 1 0 1.5h-3zm3.75-.75a.75.75 0 0 0-.75.75V12A.75.75 0 1 0 6 12V4.5a.75.75 0 0 0-.75-.75M15 4.5V12a.75.75 0 1 1-1.5 0V4.5a.75.75 0 1 1 1.5 0m-3.75-.75a.75.75 0 0 0-.75.75V12a.75.75 0 1 0 1.5 0V4.5a.75.75 0 0 0-.75-.75M7.5 4.5a.75.75 0 0 1 1.5 0V12a.75.75 0 1 1-1.5 0z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }